import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { i18n } from "src/boot/i18n"
import { useAuthStore } from "src/stores/authStore"
import { useLocalUserSettingsStore } from "src/stores/localUserSettingsStore"
import { MainMenuType } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { getExtendedMenuDataManager } from "src/util/functions/entity"
import { MenuDataManager, MenuDataNames } from "src/util/types/dataModels/entityDefinition"
import { PropType, ref } from "vue"
import { useRoute } from "vue-router"

//region Props and Emits

type ExtendedMenuDataList = {
  model: keyof typeof extendedMenuState
  label: string
  items: MenuDataManager[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxExtendedMenuManager',
  props: {
  activeExtendedTab: {
    type: String as PropType<MenuDataNames>,
  },
},
  setup(__props) {

const props = __props

//endregion

//region Variables

const { selectedWorkspace } = useAuthStore()
const { extendedMenuState } = useLocalUserSettingsStore()
const route = useRoute()
const workspaceId = selectedWorkspace?.id ?? (route.params.workspaceId as string)
const { t } = i18n.global

const workspaceListMenu = getExtendedMenuDataManager(MainMenuType.WORKSPACES, workspaceId)
const menuItemDataList = ref<ExtendedMenuDataList[]>([
  // WORK-RELATED
  {
    model: "openWorkRelated",
    label: t("sfxNavigation.group_name_work_related"),
    items: [
      MainMenuType.ISSUES,
      MainMenuType.WORK_ORDERS,
      MainMenuType.PERFORMED_WORK,
      MainMenuType.AUDIT,
    ].map((item) => getExtendedMenuDataManager(item, workspaceId)),
  },

  // REGISTRY ENTITIES
  {
    model: "openRegistryEntities",
    label: t("sfxNavigation.group_name_registry_entities"),
    items: [MainMenuType.ITEMS, MainMenuType.MODELS, MainMenuType.IDENTIFY].map((item) =>
      getExtendedMenuDataManager(item, workspaceId)
    ),
  },

  // ARRANGEMENTS
  {
    model: "openArrangement",
    label: t("sfxNavigation.group_name_arrangement"),
    items: [
      MainMenuType.LOCATIONS,
      MainMenuType.AREAS,
      MainMenuType.ZONES,
      MainMenuType.WORK_DOMAINS,
      MainMenuType.LAYOUTS,
    ].map((item) => getExtendedMenuDataManager(item, workspaceId)),
  },

  // ADMIN
  {
    model: "openAdmin",
    label: t("sfxNavigation.group_name_admin"),
    items: [MainMenuType.ANALYTICS].map((item) => getExtendedMenuDataManager(item, workspaceId)),
  },
])

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!
  const _component_q_list = _resolveComponent("q-list")!

  return (_openBlock(), _createBlock(_component_q_list, { class: "sfx-extended-menu bg-white scroll" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_item, {
        class: "sfx-extended-menu-item",
        to: _unref(workspaceListMenu).to,
        disable: _unref(workspaceListMenu).disable,
        clickable: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { avatar: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: _unref(workspaceListMenu).icon,
                size: "20px",
                class: "q-ml-md"
              }, null, 8, ["name"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_item_section, { class: "button-small" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(workspaceListMenu).label), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["to", "disable"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItemDataList.value, (group, listIndex) => {
        return (_openBlock(), _createBlock(_component_q_expansion_item, {
          key: listIndex,
          modelValue: _unref(extendedMenuState)[group.model],
          "onUpdate:modelValue": ($event: any) => ((_unref(extendedMenuState)[group.model]) = $event),
          "expand-icon-class": "hidden"
        }, {
          header: _withCtx(() => [
            _createVNode(_component_q_icon, {
              name: _unref(extendedMenuState)[group.model] ? _unref(Icons).COLLAPSE : _unref(Icons).EXPAND,
              size: "25px",
              class: "text-navy-base q-mr-md q-mt-xs"
            }, null, 8, ["name"]),
            _createVNode(_component_q_item_section, { class: "button-small text-navy-base" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(group.label), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.label
              }, [
                (item.externalLink)
                  ? (_openBlock(), _createBlock(_component_q_item, {
                      key: 0,
                      class: "sfx-extended-menu-item",
                      href: item.externalLink,
                      target: '_blank',
                      disable: item.disable,
                      clickable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: item.icon,
                              size: "20px",
                              class: "q-ml-md"
                            }, null, 8, ["name"]),
                            (item.hasNotification)
                              ? (_openBlock(), _createBlock(_component_q_badge, {
                                  key: 0,
                                  class: "q-ma-sm",
                                  color: "secondary",
                                  floating: "",
                                  rounded: ""
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, { class: "button-small" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["href", "disable"]))
                  : (_openBlock(), _createBlock(_component_q_item, {
                      key: 1,
                      class: "sfx-extended-menu-item",
                      to: item.to,
                      disable: item.disable,
                      active: item.name === props.activeExtendedTab,
                      clickable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_item_section, { avatar: "" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_icon, {
                              name: item.icon,
                              size: "20px",
                              class: "q-ml-md"
                            }, null, 8, ["name"]),
                            (item.hasNotification)
                              ? (_openBlock(), _createBlock(_component_q_badge, {
                                  key: 0,
                                  class: "q-ma-sm",
                                  color: "secondary",
                                  floating: "",
                                  rounded: ""
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_item_section, { class: "button-small" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1032, ["to", "disable", "active"]))
              ], 64))
            }), 128))
          ]),
          _: 2
        }, 1032, ["modelValue", "onUpdate:modelValue"]))
      }), 128))
    ]),
    _: 1
  }))
}
}

})